import { baseApi } from "../api";

export const deeplinkApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		handleDeeplink: builder.mutation({
			query: (body) => {
				const queryParams = new URLSearchParams();
				for (const key in body) {
					queryParams.append(key, body[key]);
				}
				return {
					url: `/rest/deeplink?${queryParams.toString()}`,
					method: "POST"
				};
			}
		})
	})
});

export const { useHandleDeeplinkMutation } = deeplinkApi;
